import FullLayout from "./FullLayout";

export default FullLayout;
